import { Component, type ErrorInfo, type ReactNode } from "react";
import { COLORS, RADIUS, SPACE, TYPE } from "../theme/index.js";

type Props = { children: ReactNode; fallback?: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error: Error): State {
    return { error };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        this.props.fallback ?? (
          <div style={{ padding: SPACE[8], textAlign: "center" }}>
            <div
              style={{
                display: "inline-block",
                padding: SPACE[6],
                background: COLORS.dangerBg,
                border: `1px solid ${COLORS.danger}`,
                borderRadius: RADIUS.xl,
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: TYPE.size.lg,
                  fontWeight: TYPE.weight.semibold,
                  color: COLORS.danger,
                }}
              >
                Something went wrong
              </p>
              <p
                style={{
                  margin: `${SPACE[2]}px 0 0`,
                  fontSize: TYPE.size.sm,
                  color: COLORS.textMuted,
                }}
              >
                {this.state.error.message}
              </p>
            </div>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
